import {useContext} from 'react';
import {DownloadSegundoPlanoContext} from "./DownloadSegundoPlanoProvider";

export default function useDownloadSegundoPlano() {
    return useContext(DownloadSegundoPlanoContext);
}
